<div *ngIf="loading" class="loader-overlay">
  <div class="loader"></div>
</div>
<div id="app" class="w-100 app-shell">
  <app-header *ngIf="showNavbar"></app-header>
  <main class="app-content">
    <router-outlet></router-outlet>
  </main>
  <app-footer-section *ngIf="showFooter"></app-footer-section>
  <app-floating-services></app-floating-services>
</div>

<!-- Auth Modal (shown when a guest tries to access a protected route) -->
<div class="auth-modal-overlay" *ngIf="showAuthModal" (click)="closeAuthModal()" (window:keydown.escape)="closeAuthModal()">
  <div class="auth-modal-content" (click)="$event.stopPropagation()"
       [dir]="currentLang === 'ar' ? 'rtl' : 'ltr'"
       role="dialog"
       aria-modal="true"
       aria-labelledby="auth-modal-title">
       
    <div class="modal-header">
      <button class="close-btn" (click)="closeAuthModal()" [attr.aria-label]="'authModal.close' | translate">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="modal-icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d23a5e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
      </svg>
    </div>
    <h3 id="auth-modal-title">{{ 'authModal.title' | translate }}</h3>
    <p>{{ 'authModal.subtitle' | translate }}</p>
    
    <div class="auth-modal-actions">
      <button class="btn-login" (click)="goToAuth('login')">{{ 'authModal.login' | translate }}</button>
      <button class="btn-signup" (click)="goToAuth('signup')">{{ 'authModal.signup' | translate }}</button>
    </div>
  </div>
</div>
